// utils/Helper.tsx

import { LocationData } from 'types/LocationData'

export const formatLocationData = (data: any): LocationData | null => {
  if (!data || !Array.isArray(data.data) || data.data.length === 0) {
    console.error('Invalid input data format or empty data.')
    return null
  }

  const item = data.data[0] // Use the first object from the array inside 'data'

  return {
    id: item.id,
    addressFull: item.addressFull,
    postcode: item.postcode,
    neighborhood: item.neighborhood,
    district: item.district,
    city: item.city,
    subregion: item.subregion,
    region: item.region,
    country: item.country,
    addressShort: item.addressShort,
    xCoordinate: item.xCoordinate,
    yCoordinate: item.yCoordinate,
    xMin: item.xMin,
    yMin: item.yMin,
    xMax: item.xMax,
    yMax: item.yMax,
    mapboxDetails: null,
    regionAnswer: null,
    wkid: item.wkid,
    text: item.addressFull,
  }
}

export const isLocationData = (data: any): data is LocationData => {
  return data && typeof data === 'object' && 'id' in data
}
